document.addEventListener('DOMContentLoaded', function () {
    if ($('.js-csv-upload-dropzone').length) {
        const dropZone = document.querySelector('.js-csv-upload-dropzone');
        const fileInput = document.querySelector('.js-csv-upload-file-input');
        const fileNameDisplay = document.querySelector(
            '.js-csv-upload-file-name'
        );
        const errorBlock = document.querySelector('.js-csv-upload-file-error');

        // Handle file input change (manual select)
        fileInput.addEventListener('change', function () {
            const file = fileInput.files[0];

            if (!file) {
                fileNameDisplay.textContent = 'No file chosen';
                errorBlock.textContent = '';
                return;
            }

            if (!isValidCsv(file.name)) {
                errorBlock.textContent = 'Only CSV files are allowed.';
                fileInput.value = ''; // Reset input
                fileNameDisplay.textContent = 'No file chosen';
            } else {
                errorBlock.textContent = '';
                fileNameDisplay.textContent = file.name;
            }
        });

        // Drag Over
        dropZone.addEventListener('dragover', function (e) {
            e.preventDefault();
            dropZone.classList.add('dragover');
        });

        // Drag Leave
        dropZone.addEventListener('dragleave', function () {
            dropZone.classList.remove('dragover');
        });

        // Drop
        dropZone.addEventListener('drop', function (e) {
            e.preventDefault();
            dropZone.classList.remove('dragover');

            const droppedFile = e.dataTransfer.files[0];
            if (!droppedFile) return;

            if (!isValidCsv(droppedFile.name)) {
                errorBlock.textContent = 'Only CSV files are allowed.';
                fileInput.value = ''; // Clear input
                fileNameDisplay.textContent = 'No file chosen';
            } else {
                errorBlock.textContent = '';
                fileInput.files = e.dataTransfer.files;
                fileNameDisplay.textContent = droppedFile.name;
            }
        });

        // Helper: Validate CSV extension
        function isValidCsv(fileName) {
            const lowerCaseName = fileName.toLowerCase();
            return lowerCaseName.endsWith('.csv');
        }
    }
});
